import { render, staticRenderFns } from "./purchasingCollecting.vue?vue&type=template&id=dfea973a"
import script from "./purchasingCollecting.vue?vue&type=script&lang=js"
export * from "./purchasingCollecting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports